export default "__VITE_ASSET__60abf474__"